import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { styled, type StyledProps } from '@compiled/react';

// This is a copy of confluence/next/packages/company-hub/src/hub-layout/HubRendererWrapper.tsx
// For now we should keep them in sync until Confluence is fully migrated to hub-renderer
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
export const HubRendererWrapper: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
> = styled.div({
	// removing 96 gutter (akEditorBreakoutPadding) width by appling negative margin
	// this increases the width of extension by 96px
	// we have to adjust this value
	// in Editor we adds 40px in the same way
	// to compensate the difference we limit the width of extension to
	// 704px - default (800 - 96)
	// 955px - wide (1051 - 96)
	// 1744px - full width (1840 - 96)
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& .ak-renderer-document, & [data-multibodiedextension-container]': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div.ak-renderer-extension': {
			padding: '0 48px',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
			'& > div.ak-renderer-extension-overflow-container': {
				margin: '0 -48px',
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div.ak-renderer-extension[data-layout=default]': {
			// extensions with default layout should have 800px max-width
			// for screens larger than 736px we limit the max-width to 704px -> 704+48*2 = 800
			// for screens smaller than 736px we limit the max-width to 100% - 32px -> 100% - 32 + 48*2 = 100% + 64(page padding) -> full width
			maxWidth: 'min(704px, calc(100% - 32px))',
			// positioning extension with default layout in the center
			// in the same way as we do for wide and full-width extensions
			// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
			marginLeft: '50%',
			transform: 'translateX(-50%)',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div.ak-renderer-extension[data-layout=wide]': {
			maxWidth: '955px',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div.ak-renderer-extension[data-layout=full-width]': {
			maxWidth: '1744px',
		},
	},

	// This override is removing the marging between MBEs (Sections and any other future MBE extensions)
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'[data-multiBodiedExtension-container] + [data-multiBodiedExtension-container]': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > .ak-renderer-extension': {
			marginTop: 0,
		},
	},

	// Removing the margin between MBE and any extension
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'[data-multiBodiedExtension-container] + div.ak-renderer-extension': {
		marginTop: 0,
	},

	// Removing the margin between any extension and MBE
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'div.ak-renderer-extension + [data-multiBodiedExtension-container]': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > .ak-renderer-extension': {
			marginTop: 0,
		},
	},

	// Removing the margin between any extensions
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'div.ak-renderer-extension + div.ak-renderer-extension': {
		marginTop: 0,
	},
});
